import QRCode from 'qrcode.react'
import React from 'react'

import { useQrcodeUrlenerator } from '../../utils/helpers/qrcodes'

const _Qrcode = ({ id, qrcode, recordId, ...props }) => {
  const genUrl = useQrcodeUrlenerator()

  return (
    <QRCode
      value={genUrl(id || qrcode.id, recordId)}
      renderAs="svg"
      fgColor="black"
      bgColor="white"
      level="H"
      {...props}
    />
  )
}

export default _Qrcode
